r<template>
  <div class="row mx-2 my-3 pricelist-settings">
      <div class="col-md-12">
          <div class="row">
              <div class="col-sm-12 col-md-7">
                  <h3>Security Info</h3>
              </div>
              <div class="col-sm-12 col-md-3 text-right">
              </div>
              <div class="col-sm-12 col-md-2 text-right">
              </div>
          </div>
          <table
              class="table table-responsive table-striped border-bottom mt-2"
          >
              <thead class="thead-light">
                  <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Is MSRP</th>
                      <th>Is MAP</th>
                      <th>Is MTP</th>
                      <th>Start Date</th>
                  </tr>
              </thead>
              <tbody>
                  <template
                      v-for="(item, key) in pricelists.data"
                      :key="item.id"
                  >
                      <tr>
                        <td>{{ item.id }}</td>
                        <td>{{ item.pricelist_name }}</td>
                        <td>
                          <ToggleInput
                            :initial-state="item.is_msrp"
                            @update:modelValue="() => handleIsMSRPChange(item.id)"
                            @error="handleError"
                          />
                        </td>
                        <td>
                          <ToggleInput
                            :initial-state="item.is_map"
                            @update:modelValue="() => handleIsMAP(item.id)"
                            @error="handleError"
                          />
                        </td>
                        <td>
                          <ToggleInput
                            :initial-state="item.is_mtp"
                            @update:modelValue="() => handleIsMTP(item.id)"
                            @error="handleError"
                          />
                        </td>
                        <td>{{ item.start_date }}</td>
                      </tr>
                  </template>
              </tbody>
          </table>

          <Bootstrap4Pagination
              :data="pricelists"
              @pagination-change-page="getResults"
              :align="'right'"
              :limit="1"
              :keepLength="true"
          >
              <template #prev-nav>
                  <i class="fa fa-arrow-left"></i> PREVIOUS</template
              >
              <template #next-nav>
                  NEXT <i class="fa fa-arrow-right"></i>
              </template>
          </Bootstrap4Pagination>
      </div>

  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import Confirmation from "@/components/Confirmation.vue";
import LockUnlockButton from "../../components/LockUnlockButton.vue"
import ForcePasswordResetButton from "../../components/ForcePasswordResetButton.vue"
import DateFormatter from "../DateFormatter.vue";
import TwoFactorToggle from "./TwoFactorToggle.vue";
import ToggleInput from "./ToggleInput.vue";

export default {
  name: "SecurityInfo",
  components: {
    Bootstrap4Pagination,
    Confirmation,
    LockUnlockButton,
    ForcePasswordResetButton,
    DateFormatter,
    TwoFactorToggle,
    ToggleInput
  },
  
  setup() {
    const store = useStore();
    const route = useRoute();

    const authUser = computed(() => store.state.user);
    const pricelists = computed(() => store.getters.getPricelists);

    onMounted(async () => {
      await store.dispatch("fetchPricelists");
    });

    return {
      store,
      route,
      authUser,
      pricelists,
    };
  },
  
  data() {
    return {
      search: '',
      currentPage: 1
    };
  },
  
  methods: {
    async getResults(page = 1) {
      this.currentPage = page;

      try {

        await this.store.dispatch('fetchPricelists', {
          page: page,
          search: this.search
        });
      } catch (err) {
        console.error(err);
      }
    },

    async handleIsMSRPChange(pricelistId) {
      try {
        await this.store.dispatch('toggleIsMSRP', pricelistId);
        this.getResults(this.currentPage);
      } catch (error) {
        console.error(error)
      }
    },

    async handleIsMAP(pricelistId) {
      try {
        await this.store.dispatch('toggleIsMAP', pricelistId);
        this.getResults(this.currentPage);
      } catch (error) {
        console.error(error)
      }
    },
    async handleIsMTP(pricelistId) {
      try {
        await this.store.dispatch('toggleIsMTP', pricelistId);
        this.getResults(this.currentPage);
      } catch (error) {
        console.error(error)
      }
    },

    handleSuccess() {
      this.getResults();
    },

    handleError(error) {
      console.error(error);
    }
  }
};
</script>